// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./autobahn_client_core/cartridges/workwear_client_core/cartridge/client/default/js/productDetail.js");
